import { render } from "./RecursiveTaxonomyButtons.vue?vue&type=template&id=782aaefe&scoped=true&ts=true"
import script from "./RecursiveTaxonomyButtons.vue?vue&type=script&lang=ts"
export * from "./RecursiveTaxonomyButtons.vue?vue&type=script&lang=ts"

import "./RecursiveTaxonomyButtons.vue?vue&type=style&index=0&id=782aaefe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782aaefe"]])

export default __exports__